export const ADD = "ADD"
export const RESET = "RESET"

export const ROUTE_TO_SECOND_SCREEN = 'ROUTE_TO_SECOND_SCREEN';